import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import {ref} from 'vue';

export async function history(testWorkQueuePhaseId, includeTestWorkQueueRequests = false) {
  const axios = axiosInstance().primoLab;
  const wareHouseHistory = ref([]);
  const params = {
    id: testWorkQueuePhaseId,
  };

  if (includeTestWorkQueueRequests) {
    params.include_test_work_queue_requests = 1;
  }

  await axios
    .get("/warehouse-requests/test-work-queue-phase", {
      params,
    }).then(async (response) => {
      wareHouseHistory.value = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { wareHouseHistory };
}
